import { cn } from "@/lib/utils";
import { LogoTile } from "@/components/brand/logo-mark";
import { Wordmark } from "@/components/brand/wordmark";

// Full brand lockup: the gradient logo tile beside the lowercase wordmark.
// The wordmark text supplies the accessible name, so the tile stays decorative.
// Drop-in replacement for a bare <Wordmark /> in headers, footers, and nav.
export function Logo({
  className,
  tileClassName,
  wordmarkClassName,
}: {
  className?: string;
  tileClassName?: string;
  wordmarkClassName?: string;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <LogoTile className={tileClassName} />
      <Wordmark className={wordmarkClassName} />
    </span>
  );
}
